import styled from 'styled-components';

export const DailyGoalContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background-color: #2a2a2a;
    border-radius: 5px;
    width: 400px;
    padding: 1em;

    h1 {
        font: bold normal 18px 'Roboto';
        text-align: center;
    }
    p {
        font: bold normal 20px "Roboto";
        text-align: center;
        margin-top: .75em;
    }
`
export const GoalHeader = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 90%;

    h1.edit-goal {
        color: #3ee9f7;
        cursor: pointer;
    }
    h1.daily-goal {
        font-size: larger;
    }
`
export const GoalWrapper = styled.div`
    display: flex;
    flex-direction: row;  
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 1em;
    
    div.goal-donut {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 200px;
        width: 180px;
    }
    div.goal {
        width: 40%;
        p.daily-goal {
            font-size: 40px;
            color: #3ee9f7;
            line-height: 0.9;
            margin-top: -45px;
            span {
                color: #fff;
                font-size: 22px;
            }
        }
    }
`

export const GraphWrapper = styled.div`
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 0 1em;
`





// WEBPACK FOOTER //
// ./src/components/OnBoard/Plexing/DailyGoal/DailyGoal.styles.ts